import axios from "axios";
import Alert from "react-s-alert";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_CART_DATA,
  CLEAR_ERRORS,
  CLEAR_LOADER,
  GET_VENDOR_ALL_TAKEAWAY_ORDER,
  ORDER_ID,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  GET_ALL_DEBIT_CREDIT_MEMO,
  VIEW_MEMO_DETAILS,
  APPLY_OFFER_VENDOR,
  SUGGESTIONS_DATA,
  SET_ORDER_TIP,
  SET_ORDER_TYPE_DETAILS,
  CLEAR_ORDER_TYPE_DETAILS,
} from "../../types";
import { setErrors } from "../errorActions";
import { amApi } from "../../../api/apiHelper";

/***************************************
 * @DESC - ADD ORDER VENDOR
 *****************************************/
export const add_order_vendor_side =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_order_vendor_side = await axios.post(
        `${serverApi}/ordering`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_order_vendor_side.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Order Added Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET ALL ACTIVE VENDORS ACTION
 *****************************************/
export const get_all_order_vendor_side =
  (token, orderType, orderStatus, date, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_active_vendors = await axios.get(
        `${serverApi}/ordering?${orderStatus === 0 ? "" : `date=${date}`}${orderType === 10 ? "" : `&order_type=${orderType}`
        }${orderStatus === 10
          ? "&order_status=all"
          : `&order_status=${orderStatus}`
        }`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_active_vendors.status === 200) {
        //   if (orderType === 0) {
        dispatch({
          type: GET_VENDOR_ALL_TAKEAWAY_ORDER,
          payload: get_active_vendors.data,
        });
        //   } else if (orderType === 1) {
        //     dispatch({
        //       type: GET_VENDOR_ALL_CURBSIDE_ORDER,
        //       payload: get_active_vendors.data,
        //     });
        //   } else if (orderType === 3) {
        //     dispatch({
        //       type: GET_VENDOR_ALL_DINEIN_ORDER,
        //       payload: get_active_vendors.data,
        //     });
        //   }
        onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_all_order_vendor_side_history =
  (token, dateQuery, onSuccess) => async (dispatch) => {
    try {
      let get_active_vendors = await axios.get(
        `${serverApi}/ordering?order_status=HISTORY&startDate=${dateQuery?.startDate}&endDate=${dateQuery?.endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_active_vendors.status === 200) {
        //   if (orderType === 0) {
        dispatch({
          type: GET_VENDOR_ALL_TAKEAWAY_ORDER,
          payload: get_active_vendors.data,
        });
        //   } else if (orderType === 1) {
        //     dispatch({
        //       type: GET_VENDOR_ALL_CURBSIDE_ORDER,
        //       payload: get_active_vendors.data,
        //     });
        //   } else if (orderType === 3) {
        //     dispatch({
        //       type: GET_VENDOR_ALL_DINEIN_ORDER,
        //       payload: get_active_vendors.data,
        //     });
        //   }
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch(setErrors(err));
    }
  };

export const edit_order_vendor_side =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_active_vendors = await axios.patch(
        `${serverApi}/ordering/${formData.id}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_active_vendors.status === 200) {
        Alert.success(`<h4>Status Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const edit_order_vendor_v2 =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_active_vendors = await axios.patch(
        `${serverApi}/merchant/ordering/${formData.id}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_active_vendors.status === 200) {
        Alert.success(`<h4>Status Updated Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const edit_location = (formData) => async (dispatch) => {
  try {
    let get_active_vendors = await amApi.patch(
      `/ordering/${formData.id}`,
      formData
    );
  } catch (err) {
    dispatch(setErrors(err));
  }
};

export const editTransaction = (formData, onSuccess) => async (dispatch) => {
  try {
    let get_active_vendors = await amApi.post(`/updateTransaction`, formData);
    onSuccess();
  } catch (err) {
    dispatch(setErrors(err));
  }
};

export const create_order_vedor_side =
  (token, formData, onSuccess, onErrorAddOrder) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let create_order_vendor = await axios.post(
        `${serverApi}/ordering`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (create_order_vendor.status === 201) {
        // Alert.success(`<h4>Order Created  Successfully</h4>`, {
        //   position: "top-right",
        //   effect: "bouncyflip",
        //   beep: true,
        //   html: true,
        //   timeout: 3000,
        //   offset: 35,
        // });
        dispatch({ type: CLEAR_LOADER });

        formData.payment_pending = true;
        formData.order_id = create_order_vendor.data.order_id;
        onSuccess(formData, create_order_vendor.data._id);
        dispatch({ type: ORDER_ID, payload: create_order_vendor.data._id });

        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);

        //dispatch({ type: CLEAR_CART_DATA });
        //dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      // console.log(err);
      // Alert.error(
      //   `<h4>${
      //     err && err.error && err.error.message
      //       ? err.error.message
      //       : "Unable to process your order"
      //   }</h4>`,
      //   {
      //     position: "top-right",
      //     effect: "bouncyflip",
      //     beep: true,
      //     html: true,
      //     timeout: 3000,
      //     offset: 35,
      //   }
      // );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorAddOrder(err?.response?.data?.message);
    }
  };

export const complete_all_orders =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let complete_all_orders = await axios.patch(
        `${serverApi}/ordering`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (complete_all_orders.status === 200) {
        Alert.success(`<h4>All Order Updated  Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();

        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_pay_create_order =
  (token, formData, onSuccess, orderId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    // formData.donation = {};
    // formData.donation.amount = 5;
    // formData.order_id = orderId;

    try {
      let create_order_vendor = await axios.post(
        `${serverApi}/razorpay?order=true&vendor=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (create_order_vendor.status === 201) {
        onSuccess(create_order_vendor.data, orderId);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });

        //dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      console.log(err);
      Alert.error(`<h4>Unable to process your order</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const razor_payment =
  (token, formData, onSuccess, orderId, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let razor_payment = await axios.post(
        `${serverApi}/razorpay?payments=true&vendor=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (razor_payment.status === 201) {
        onSuccess(razor_payment.data, orderId, onError);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });

        //dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      console.log(err);
      Alert.error(`<h4>Unable to process your order</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      if (onError) onError(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_or_check_user_order =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let create_chceck_user = await axios.post(
        `${serverApi}/user-check`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (create_chceck_user.status === 201) {
        onSuccess(create_chceck_user.data._id, create_chceck_user.data.email);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });

        //dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const setOrderTypeDetails = (data) => async (dispatch) => {
  try {
    dispatch({
      type: SET_ORDER_TYPE_DETAILS,
      payload: data,
    });
  } catch (err) {
    console.log(err);
  }
};

export const clearOrderTypeDetails = (data) => async (dispatch) => {
  try {
    dispatch({
      type: CLEAR_ORDER_TYPE_DETAILS,
      payload: {},
    });
  } catch (err) {
    console.log(err);
  }
};

export const debit_memo_order_cancel_item =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let debit_memo_order_cancel_item = await axios.post(
        `${serverApi}/ordering-transactionals?debitMemo=true&cancelItem=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (debit_memo_order_cancel_item.status === 201) {
        onSuccess(debit_memo_order_cancel_item.data._id);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const debit_memo_order_substitute_item =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let debit_memo_order_substitute_item = await axios.post(
        `${serverApi}/ordering-transactionals?debitMemo=true&subtituteItem=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (debit_memo_order_substitute_item.status === 201) {
        onSuccess(debit_memo_order_substitute_item.data._id);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const cancel_item_order =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_active_vendors = await axios.post(
        `${serverApi}/order-cancel-substitution?cancelItem=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_active_vendors.status === 201) {
        onSuccess();
        Alert.success(`<h4>Item Cancelled Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const edit_order_vendor_side_payment =
  (token, formData, orderId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_order_vendor_payment = await axios.patch(
        `${serverApi}/ordering/${orderId}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (edit_order_vendor_payment.status === 200) {
        onSuccess(edit_order_vendor_payment.data);
        dispatch({ type: CLEAR_LOADER });
        dispatch({ type: CLEAR_CART_DATA });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const credit_memo_substitute_item =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let credit_memo_substitute_item = await axios.post(
        `${serverApi}/ordering-transactionals?creditMemo=true&subtituteItem=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (credit_memo_substitute_item.status === 201) {
        onSuccess(credit_memo_substitute_item.data._id);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const substitute_items =
  (token, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let substitute_items = await axios.post(
        `${serverApi}/order-cancel-substitution?substituteItem=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (substitute_items.status === 201) {
        onSuccess(substitute_items.data._id);
        //   if (orderType === 0) {

        //onSuccess(orderType, orderStatus);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const vendor_get_all_debit_credit_memo =
  (token, query, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let vendor_get_memo = await axios.get(`${serverApi}/orderMemo`, {
        params: query,
        headers: {
          Authorization: token,
        },
      });
      if (vendor_get_memo.status === 200) {
        dispatch({
          type: GET_ALL_DEBIT_CREDIT_MEMO,
          payload: vendor_get_memo.data,
        });

        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_takeAway_time =
  (token, vendorId, orderType, date, onSuccess, onError) =>
    async (dispatch) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      try {
        let get_takeAway_time = await axios.get(
          `${serverApi}/order-availability/${vendorId}/?date=${date}&orderType=${orderType}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        if (get_takeAway_time.status === 200) {
          onSuccess(get_takeAway_time.data, date);
          dispatch({ type: CLEAR_LOADER });
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
        onError(err);
      }
    };

export const vendor_get_memo_id =
  (token, id, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let vendor_get_memo = await axios.get(`${serverApi}/orderMemo/${id}`, {
        headers: {
          Authorization: token,
        },
      });
      if (vendor_get_memo.status === 200) {
        dispatch({
          type: VIEW_MEMO_DETAILS,
          payload: vendor_get_memo.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const apply_offer_code =
  (token, queryData, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let apply_offer_code = await axios.post(
        `${serverApi}/user/offers`,
        queryData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (apply_offer_code.status === 201) {
        const formData = {
          isPercentage: apply_offer_code?.data?.isPercentage,
          discountAmount: apply_offer_code?.data?.discount,
          coupon_code: apply_offer_code?.data?.coupon_code,
          isOfferApplied: true,
          type: apply_offer_code?.data?.type,
          deliveryMaxDiscount: apply_offer_code?.data?.deliveryMaxDiscount,
          deliveryMinOrder: apply_offer_code?.data?.deliveryMinOrder,
          isDelivery: apply_offer_code?.data?.isDelivery
        };
        onSuccess();
        dispatch({ type: APPLY_OFFER_VENDOR, payload: formData });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      onError(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_suggested_items =
  (token, formData, onSuccess) => async (dispatch) => {
    // dispatch({ type: CLEAR_ERRORS });
    // dispatch({ type: SET_LOADER });

    try {
      let vendor_get_memo = await axios.post(
        `${serverApi}/user/menu-category?cross_selling=true`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (vendor_get_memo.status === 201) {
        dispatch({
          type: SUGGESTIONS_DATA,
          payload: vendor_get_memo.data,
        });
        onSuccess(vendor_get_memo.data);
        //dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
